var map = {
	"./GCIH.png": 1841,
	"./GFACT.png": 8658,
	"./GSEC.png": 5227,
	"./Powershell.svg": 3958,
	"./WiCys.jpg": 8653,
	"./WiCysScholar.jpg": 9833,
	"./airbnbLogo.png": 3783,
	"./burpsuite.svg": 6584,
	"./camosun.png": 4201,
	"./contactMail.webp": 8640,
	"./contactMailDark.svg": 3527,
	"./developerActivity.svg": 36,
	"./facebookLogo.png": 34,
	"./gnubash.svg": 4383,
	"./googleAssistant.svg": 760,
	"./jfrog.svg": 5673,
	"./jsFramework.svg": 860,
	"./manOnTable.svg": 8776,
	"./nextuLogo.webp": 2953,
	"./nmap.svg": 6320,
	"./programmer.svg": 522,
	"./quoraLogo.png": 8967,
	"./saayaHealthLogo.webp": 7788,
	"./skill.svg": 1601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;